// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Receipts = {
  receiptsList: null,
  receiptsListFetched: false,
  downloadingId: null,
  downloadingError: false,
};
